import React from 'react'
import Dropzone from 'react-dropzone'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import uploadImage from 'assets/images/sessions-upload.png'

const classes = {
  dropAreaWrapper: 'droparea-wrapper',
}

const Root = styled('section')(({ theme }) => ({
  [`.${classes.dropAreaWrapper}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '290px',
  },
}))

export default function DropArea(props) {
  return (
    <Dropzone
      noClick={true}
      noKeyboard={true}
      {...props}
      data-testid={'drop-area'}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <Root>
          <div {...getRootProps()} className={classes.dropAreaWrapper}>
            <input {...getInputProps()} />
            <Box
              component="img"
              src={uploadImage}
              width={0.5}
              maxWidth="450px"
              sx={{
                opacity: (theme) =>
                  props.disabled ? '0.5' : isDragActive ? '1' : '0.75',
              }}
            />
          </div>
        </Root>
      )}
    </Dropzone>
  )
}
